import React from "react";

import { Form, Spinner, Table } from "react-bootstrap";
import { get } from "sites-common/utils/lodash";
import PropTypes from "prop-types";

const PricingDetails = ({ pricingData, selectedPrice, hideHeader = false }) => {
  if (pricingData.loading) {
    return (
      <div className="pricing_details" style={{ marginBottom: "20px" }}>
        <Spinner animation="border" style={{ color: "#b0853a" }} />
      </div>
    );
  }
  return (
    <div className="pricing_details" style={{ marginBottom: "20px" }}>
      {pricingData.s.length ? (
        <div className="card">
          <Table responsive borderless cellSpacing={0}>
            {!hideHeader && (
              <thead>
                <tr key="price">
                  <td key="desc">Description</td>
                  <td key="price">Price</td>
                  <td key="action" />
                </tr>
              </thead>
            )}
            <tbody>
              {pricingData.s.map((pd) => (
                <tr key={pd.name}>
                  <td style={{ textAlign: "center" }}>
                    <Form.Check
                      inline
                      label=""
                      defaultChecked={pd.sku === pricingData.s[0].sku}
                      name="pricingSelect"
                      type="radio"
                      id={pd.sku}
                      role="button"
                      onClick={() => selectedPrice(pd)}
                    />
                  </td>
                  <td>{get(pd, "desc", "")}</td>
                  <td>{`${(
                    Math.round(get(pd, "rate", "-") * 100) / 100
                  ).toFixed(2)} ${get(pd, "currency", "")}`}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        " "
      )}
    </div>
  );
};

PricingDetails.defaultProps = {
  pricingData: {
    loading: true,
    s: [],
  },
  hideHeader: false,
};

PricingDetails.propTypes = {
  pricingData: PropTypes.objectOf(PropTypes.any),
  selectedPrice: PropTypes.func.isRequired,
  hideHeader: PropTypes.bool,
};

export default PricingDetails;
